export const name = "SAFE_MULTIPLY";
export const summary = `Equivalent to the multiplication operator (\`X * Y\`), but returns \`NULL\` if overflow occurs.`;
export const reference = `
## SAFE_MULTIPLY

Equivalent to the multiplication operator (\`X * Y\`), but returns \`NULL\` if overflow occurs.

\`\`\`
SAFE_MULTIPLY(X, Y)
\`\`\`

### Description

Equivalent to the multiplication operator (\`*\`), but returns\`NULL\` if overflow occurs.

| X | Y | SAFE\\_MULTIPLY(X, Y) |
| --- | --- | --- |
| 20 | 4 | 80 |


### Return Data Type

| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| --- | --- | --- | --- | --- |
| \`INT64\` | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| \`NUMERIC\` | \`NUMERIC\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| \`FLOAT64\` | \`FLOAT64\` | \`FLOAT64\` | \`FLOAT64\` | \`FLOAT64\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
